/* *******************************      FUNCTIONS      ******************************* */
/* *******************************      FUNCTIONS      ******************************* */
/* *******************************      FUNCTIONS      ******************************* */

var docCookies = {
  getItem: function (sKey) {
    if (!sKey) { return null; }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          /*
          Note: Despite officially defined in RFC 6265, the use of `max-age` is not compatible with any
          version of Internet Explorer, Edge and some mobile browsers. Therefore passing a number to
          the end parameter might not work as expected. A possible solution might be to convert the the
          relative time to an absolute time. For instance, replacing the previous line with:
          */
          /*
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; expires=" + (new Date(vEnd * 1e3 + Date.now())).toUTCString();
          */
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
  }
};


// FUNCTION: FORMATPRICE
// FUNCTION: FORMATPRICE
// FUNCTION: FORMATPRICE
function formatPrice(price){
  
  var formatPrice = Shopify.formatMoney(price, Theme.moneyFormat);
  
  return formatPrice;
}

// FUNCTION: ADD FRAME TO CART
// FUNCTION: ADD FRAME TO CART
// FUNCTION: ADD FRAME TO CART
function addFrameToCart($addToCartForm, $addToCartBtn){

  // CODE Only for Gift Item
  const giftItemId = parseInt(document.querySelector('#giftItemProductId').dataset.id)
  const isGiftEnabled = document.querySelector('#giftItemProductId').hasAttribute('data-gift')

    
    const cartItems = document.querySelectorAll('.mini-cart-item')
    const itemsArray = []
    cartItems.forEach(item => itemsArray.push(item.attributes['data-variant'].value))

    const hasGiftItem = itemsArray.some( item => parseInt(item) === giftItemId)

    const minGiftValue = parseInt(100000) || 135000

    function getCart() {
      $.getJSON('/cart.js', function(cart) {
        console.log("Cart total", cart.total_price)
        if (cart.total_price >= minGiftValue) {
          addGift()
        }
      })
    }

    function addGift() {
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: { id: giftItemId, quantity: 1},
        dataType: 'json',
        success: function(cart) {
          updateCart(cart)
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest, textStatus)
        },
        // async: false
      }; 
      if(hasGiftItem) {
        console.log('Gift item already in cart')
      } else {
        $.ajax(params)
      }
    }
    // CODE Only for Gift Item
    
  //Product frames area
  $chosenProduct = JSON.stringify($addToCartForm.serializeArray());
  $chosenProduct = JSON.parse($chosenProduct);
  var allowed = ['oak', 'black', 'white', 'no'];
  
  console.log('$chosenProduct',$chosenProduct);
  console.log('$chosenProduct[4]',$chosenProduct[4]);
  
  if($chosenProduct[5] && $chosenProduct[5].name == 'product-frame'){
    $frameType = $chosenProduct[5].value;
  }

  if($chosenProduct[4] && $chosenProduct[4].name == 'option-0'){
    $productSize = $chosenProduct[4].value.replace(' cm', '');
  }

  console.log('$frameType',$frameType);
  console.log('$productSize',$productSize);
  
  if(typeof $frameType !== 'undefined' && typeof $productSize !== 'undefined' && $frameType !== 'no'){
    if(productFrames[$frameType]['sizesAvailable']($productSize)){

      $idFrame = parseInt(productFrames[$frameType]['sizesAvailable']($productSize)[1]);

      if($idFrame){
        $.ajax({
          data      : {quantity: 1, id: $idFrame},
          dataType  : 'json',
          error     : function (XMLHttpRequest) {
            alert("Der skete desværre en fejl i tilføjelsen af en ramme, prøv at genindlæse siden");
          },
          success   : function (item) {
            
            //$('.product-message .frame-added-to-cart').text(item.title + ' er lagt i din indkøbskurv.');
            $addToCartBtn.val("Tilføjet til kurv");
            if ( $('.frame-selector .swatch').has('input:checked').index() > 0 && isGiftEnabled) {
              getCart()
            }
            /*
            $.getJSON("/cart.js", function (cart) {
              
              refreshCart(cart);
              
              window.setTimeout(function () {
                $.fancybox.close();
              }, 500);
              
            });
            */
          },
          type      : 'post',
          url       : '/cart/add.js'
        });
        
      }else{
        alert('Error in add to cart');  
      }  
    }
  }
}

// FUNCTION: CHANGE PRICE
// FUNCTION: CHANGE PRICE
// FUNCTION: CHANGE PRICE
function changePrice(type){
  
  //console.log('Action: Change Price')
  //console.log('Parameter supplied: type=',type);

  var basePrice = JSON.parse(localStorage.getItem('selectedVariant')).price;
  var basePriceCompare = JSON.parse(localStorage.getItem('selectedVariant')).compare_at_price;

  if(!basePrice){
    alert("Der skete desværre en uventet fejl, genindlæs venligst siden");
    return false;
  }
  
  if(type !== 'no') {
    
    var productSize = $('.sizes-selectors:checked').val().replace(' cm', '');
      
    if(undefined !== productFrames[type]['sizesAvailable'](productSize)){
     
      var framePrice = productFrames[type]['sizesAvailable'](productSize)[0];
      var priceTotal = formatPrice(framePrice+basePrice);
      var $priceCompareEl = $('.product-price-compare');
      //var basePriceCompare = parseInt( $priceCompareEl.text().substr(0,6).replace(',','') );		// 395,00 kr-> 39500
      var newPriceCompare = formatPrice(framePrice+basePriceCompare);
      
      
      console.log('basePrice:',basePrice);
      console.log('framePrice:',framePrice);
      console.log('basePriceCompare:',basePriceCompare);
      console.log('newPriceCompare:',newPriceCompare);
      
      /*console.log('total:',framePrice+basePrice);
      console.log('priceTotal var:',priceTotal);
      console.log("$('.product-price-minimum')",$('.product-price-minimum').length);
      console.log("$('.product-price-minimum')",$('.product-price-minimum').html());
      */
      
      $('.product-price-minimum').html(priceTotal);
      $('.product-price-compare').html(newPriceCompare);
      
    }
    
  }else{
    $('.product-price-minimum').html(formatPrice(basePrice));
    $('.product-price-compare').html(formatPrice(basePriceCompare));
  }
}

// FUNCTION: LOAD FRAME PRICES IN TOOLTIP
// FUNCTION: LOAD FRAME PRICES IN TOOLTIP
// FUNCTION: LOAD FRAME PRICES IN TOOLTIP
function loadPricesFrame($elm){
  
  if ( $elm.length ) {
  	console.log("LOAD FRAME PRICES");  
    $('.frame-selector .swatch-element').each(function(index, value){
      
      var type = $(value).data('type');
      var productSize = $elm.data('size').replace(' cm', '');
      var frameName = type;
      console.log(type);
      console.log(productSize);

      if(type !== 'no'){
        var details = productFrames[type]['sizesAvailable'](productSize);
		
        console.log("loadPricesFrame details");
        console.log(details);
  		
        if (typeof(details && details[0]) !== 'undefined'){
          var price = formatPrice(details[0]);
			console.log("loadPricesFrame price");
          $(value).find('.addon-price').html('<span class="extra-name">'+type+'</span><span class="extra-cost">'+price+'</span>');
        }
      }
      
    });
    
  }
  
}


/* *******************************      LOGIC      ******************************* */
/* *******************************      LOGIC      ******************************* */
/* *******************************      LOGIC      ******************************* */

// Preload frames
// Preload frames
// Preload frames

function preloadFrameImages() {
  
  console.log("preloadFrameImages..");
  
  
  

  
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_oak_portrait.png";
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_oak_landscape.png";
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_oak_square.png";
        
  
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_black_portrait.png";
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_black_landscape.png";
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_black_square.png";
        
  
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_white_portrait.png";
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_white_landscape.png";
      
        
        img = new Image();
        img.src = "//vissevasse.dk/cdn/shop/t/23/assets/picture_frame_white_square.png";
        
  
  
  // Save the state so we don't keep on reloading the same images on every page
  //localStorage.setItem('pictureframes_loaded','true');
  //var newdate = new Date();
  //newdate.setDate( newdate.getDate() + 3 );
  //docCookies.setItem('preloadFrameImgs', 1, newdate, "/", "vissevasse.dk")
  $("body").off('mouseenter',preloadFrameImages)
}



jQuery(function($) {

  	if ( $('.template-product .product').hasClass('has-frames') )
    {	
  
      // Even if we preload images here, I guess because we swap these images using CSS, at least in Chrome, these images
      // will get loaded again when the user chooses a frame. The initiator is Other when a user initates a new image to be shown
      // So we initiate the download of these files by hooking into the mouseenter event of the body the first time they enter the site
      $("body").on('mouseenter', preloadFrameImages);
      
      // carolineschnapp - color swatches 
      // CHANGES THE VARIANT OF THE SELECT FORM FIELD WHEN RADIO BUTTONS ARE CLICKED
      $('.swatch :radio').change(function() {
          var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          var optionValue = jQuery(this).val();
          jQuery(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
      });

      // AUTO SELECT THE PICTURE SIZE VARIANT
      // AUTO SELECT THE PICTURE SIZE VARIANT
      // AUTO SELECT THE PICTURE SIZE VARIANT
      if($('.sizes-selectors').length > 0){

        switch($('.sizes-selectors[data-size="30x40 cm"]').length) {

          case 1:
            
            // THIS MEANS THAT THE 30x40 IS AVAILABLE
            
            // ON REFRESH OR BACK BUTTON, SELECT LAST CLICKED INSTED.. (LOGIC->IF LAST VARIANT SAVED EXISTS ON PAGE, SELECT IT INSTEAD OF DEFAULT)
            /*
            id_of_last_variant_selected = JSON.parse(localStorage.getItem('selectedVariant')).id;
            $lastVariantSelectedIfExists = $('.variant-selector input[data-product-variant=' + id_of_last_variant_selected + ']');
            if ( $lastVariantSelectedIfExists.length && $lastVariantSelectedIfExists.data('productVariant') == id_of_last_variant_selected ) {
            	//$('.variant-selector input[data-product-variant=' + id_of_last_variant_selected + ']').trigger('click');
            }
            else {
            
              // OTHERWISE, BY DEFAULT, THE 30x40 SHOULD BE SELECTED BY DEFAULT
			*/
              $('.sizes-selectors[data-size="30x40 cm"]').trigger('click');
              jQuery('.swatch :radio').closest('form').find('.single-option-selector').eq(0).val("30x40 cm").trigger('change');
              localStorage.setItem('productSize', "30x40");
            //}
            break;
          default:
            if($('.sizes-selectors[data-size="50x70 cm"]').length > 0){
              $('.sizes-selectors[data-size="50x70 cm"]').trigger('click');
              // Trigger the change on the hidden select drop down menu..
              jQuery('.swatch :radio').closest('form').find('.single-option-selector').eq(0).val("50x70 cm").trigger('change');
              localStorage.setItem('productSize', "50x70");
            }else{
              $('.sizes-selectors:first').trigger('click');
              jQuery('.swatch :radio').closest('form').find('.single-option-selector').eq(0).first().trigger('change');
              localStorage.setItem('productSize', jQuery('.swatch :radio').closest('form').find('.single-option-selector').eq(0).val().split(' ')[0] );
            }
        }
      }

      $('.frame-selector .swatch-element')
      
        .mousemove(function(event) {
				
        	// SHOW TOOLTIP
            // SHOW TOOLTIP
            // SHOW TOOLTIP
        
            var left = event.pageX - $('.variant-holder.product-frames').offset().left + 20;
            var top = event.pageY - $('.variant-holder.product-frames').offset().top + 20;

            //console.log (left, top);

            $(this).find('.addon-price').css({top: top,left: left}).show();

        })

        .mouseout(function() {
          
        	// HIDE TOOLTIP
            // HIDE TOOLTIP
            // HIDE TOOLTIP
          
            $(this).find('.addon-price').hide();
          
        });

      // PICTURE SIZE
      // PICTURE SIZE
      // PICTURE SIZE
      $('.sizes-selectors').on('click', function(){

        var size = $(this).val().split(' ')[0];

        localStorage.setItem('productSize', size);

        //loadPricesFrame($(this));

        function toggleFrame(type, transition){

          var container = $('.variant-holder.product-frames').find('.frame[data-type="'+type+'"]');

          if(container && transition){
            if(transition == 'hide'){
              container.hide();
            }else{
              container.show();
            }
          }

          //Reset selectors, to prevent old actives
          $('.frames-selectors').prop('checked', false);

        }

        if(size){
          if(!productFrames.white.sizesAvailable(size)){
            toggleFrame('white', 'hide');
          }else{
            toggleFrame('white', 'show');
          }

          if(!productFrames.black.sizesAvailable(size)){
            toggleFrame('black', 'hide');
          }else{
            toggleFrame('black', 'show');
          }

          if(!productFrames.oak.sizesAvailable(size)){
            toggleFrame('oak', 'hide');
          }else{
            toggleFrame('oak', 'show');
          }
        }
        
        // Show/Hide OAK on 70x100
        var $swatches = $('.swatch').has('input[value=oak]');
        if( size == "70x100") {
        	$swatches.has('input[value=oak]').hide();
          
          	if( $swatches.has('input[value=oak]:checked').length ) {
            	// if also checked, check the first one as default
              	$('#frame-no').click();
            }
        }
        else {
          	$swatches.has('input[value=oak]').show();
        }

      });

      // ON SELECTING A FRAME COLOR, CHANGE THE PRICE, CHANGE THE FRAME TYPE
      // ON SELECTING A FRAME COLOR, CHANGE THE PRICE, CHANGE THE FRAME TYPE
      // ON SELECTING A FRAME COLOR, CHANGE THE PRICE, CHANGE THE FRAME TYPE
      $('input[name="product-frame"]').on('click', function(){
        
        var size = localStorage.getItem('productSize', size);
        var type = $(this).val();
        var types = ['oak', 'black', 'white', 'no'];
        var $main_image = $('.product-main-image');
		
        // CHANGE THE FRAME TYPE ON THE MAIN IMAGE
        // CHANGE THE FRAME TYPE ON THE MAIN IMAGE
        // CHANGE THE FRAME TYPE ON THE MAIN IMAGE
        $main_image
        	.removeClass(types)	// Remove all types matching the ones in the types array
        		.addClass(type);	// Add the new selected type
   
        if(types.indexOf(type) !== -1){
          changePrice(type); 
        }
        else
        {
          alert("Der skete desværre en uventet fejl, genindlæs venligst siden");
          return false;
        }

      });
      
      // ADD/REMOVE FRAME BASED ON THUMBNAIL CLICKED
      // ADD/REMOVE FRAME BASED ON THUMBNAIL CLICKED
      // ADD/REMOVE FRAME BASED ON THUMBNAIL CLICKED      
      $('.product-thumbnail img').click(function(e)
      {
      	  
        if ( $(e.target.parentElement).hasClass('can-be-framed') )
        {
          $('.product-main-image').addClass('framed');
        }
        else {
          $('.product-main-image').removeClass('framed');
        }

      });
      
      // AUTO-TAG THE CLASS NAME OF THE FRAME BASED ON SELECTED FRAME. WORKS ON BROWSERS WHICH SUPPORTS THAT FEATURE, IE FIREFOX
      var type = $('input[name="product-frame"]:checked').val();
      $('.product-main-image').addClass(type);
      
      // Frame Selector that is located under the main image on mobile
   
      $('.frame-selector.mobile .swatch').on('click', function() {
        
      	$swatch =$(this);
        
        $swatch.siblings().removeClass('selected');
          
        $(this).addClass('selected');
        
      });

           
   }
  
}(jQuery));


// UPDATE CART
function updateCart(newItem) {
  var miniCartItemWrapper;
  $(".mini-cart").removeClass("empty");
  miniCartItemWrapper = $(".mini-cart-item-wrapper");
  return Shopify.getCart(function(cart) {
    var currencySwitcher, currencyValue, i, image, item, len, price, ref;
    miniCartItemWrapper.empty();
    $("[data-cart-count]").html("<span class=\"cart-count-text\">Indkøbskurv</span>\n(<span class=\"cart-count-number\">" + cart.item_count + "</span>)");
    ref = cart.items;
    for (i = 0, len = ref.length; i < len; i++) {
      item = ref[i];
      price = Shopify.formatMoney(item.price, Theme.moneyFormat);
      image = item.image != null ? item.image : "//vissevasse.dk/cdn/shop/t/23/assets/no-image.svg?v=159058134315431493651569305827";
      miniCartItemWrapper.append("<article\n    class=\"mini-cart-item\"\n    data-variant=\"" + item.variant_id + "\"\n    data-url=\"" + item.url + "\"\n    data-title=\"" + item.title + "\"\n>\n    <figure class=\"mini-cart-item-image\">\n        <a href=\"" + item.url + "\">\n            <img alt=\"" + item.title + "\" src=\"" + image + "\">\n        </a>\n    </figure>\n    <div class=\"mini-cart-item-details\">\n        <p class=\"mini-cart-item-quantity\">\n            Antal: <span>" + item.quantity + "</span>\n        </p>\n        <p class=\"mini-cart-item-title\">\n            <a href=\"" + item.url + "\">" + item.title + "</a>\n        </p>\n        <p class=\"mini-cart-item-price\">\n            <span class=\"money\">" + price + "</span>\n        </p>\n    </div>\n</article>");
    }
    currencySwitcher = $(".currency-switcher select");
    currencyValue = currencySwitcher.val();
    return currencySwitcher.val(Theme.currency).trigger("reset-currency").val(currencyValue).trigger("reset-currency");
  });
};